module.exports = __webpack_public_path__ + "media/images/invite_health_teams_confirmation-b31d2258.svg";